import { CancelBtn } from 'components/Button/CancelBtn'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { ISelectValue } from 'constants/globalTypes'
import { getSingleCategory } from 'features/categories/categoriesSlice'
import { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { Animation, Button, Flex, ItemsGrid, TabFooter } from 'styling/GlobalStyles'
import { ITaskTemplatesTab } from 'types/task-templates.interface'

export const TaskTMachinesTab = ({ state, setState, handleSubmit }: ITaskTemplatesTab) => {
    const dispatch = useDispatch<AppDispatch>();
    const [selectedCategory, setSelectedCategory] = useState(state.requiredMachineCategory)
    const { category } = useSelector((state: RootState) => state.categories)

    useEffect(() => {
        if (selectedCategory?.value) {
            dispatch(getSingleCategory(selectedCategory.value))
        }
    }, [selectedCategory?.value])

    useEffect(() => {
        if (
            category?.id &&
            category.id === selectedCategory?.value &&
            category.fields &&
            !state.requiredMachineModelFieldValues?.length
        ) {
            setState(prev => ({
                ...prev,
                requiredMachineModelFieldValues: category.fields.map(f => ({ field: f, id: f.id, value: null })),
            }))
        }
    }, [category, selectedCategory?.value])

    const handleInputField = (e: React.FormEvent<HTMLInputElement>) => {
        const { value, id, type } = e.target as HTMLInputElement
        setState(prev => {
            const newState = structuredClone(prev)
            const fieldIndex = newState.requiredMachineModelFieldValues.findIndex((item) => Number(item.id) === Number(id))
            if (fieldIndex > -1) {
                newState.requiredMachineModelFieldValues[fieldIndex].value = type === 'number' ? Number(value) : value
            }
            return newState
        })
    }

    const handleSelectField = (selectedValue: ISelectValue, id: number) => {
        setState(prev => {
            const newState = structuredClone(prev)
            const fieldIndex = newState.requiredMachineModelFieldValues.findIndex((item) => Number(item.id) === Number(id))
            if (fieldIndex > -1) {
                newState.requiredMachineModelFieldValues[fieldIndex].value = selectedValue.value
            }
            return newState
        })
    }

    const renderFields = () => {
        const forReturn = state?.requiredMachineModelFieldValues?.map((field) => {
            if (field.field?.dataType == 1) {
                return (
                    <Input
                        id={field.id}
                        key={1}
                        name={field.field.name}
                        value={field.value}
                        type='text'
                        labelText={field.field.name}
                        onChange={handleInputField}
                        placeholder={'Enter text ' + field.field.name}
                    />
                )
            } else if (field.field?.dataType == 2) {
                const getValue = () => {
                    const foundField = state.requiredMachineModelFieldValues.find((f) => f.id == field.id)
                    return foundField ? foundField.value : ''
                }

                return (
                    <Input
                        id={field.id}
                        key={2}
                        name={field.field.name}
                        value={getValue()}
                        type='number'
                        labelText={field.field.name}
                        onChange={handleInputField}
                        placeholder={'Enter ' + field.field.name}
                    />
                )
            } else {
                const optionsForSelect = field.field?.dropDownItems?.map((item) => ({ label: item.name, value: item.id })) || []

                return (
                    <HonestSelectInput
                        key={3}
                        name={field?.id?.toString()}
                        onChange={(value: ISelectValue) => handleSelectField(value, field?.id)} // ovde id
                        labelText={field?.field?.name}
                        defaultValue={Number(field.value)}
                        options={optionsForSelect}
                        noX
                    />
                )
            }
        })

        return forReturn
    }


    const handleSelect = v => {
        const categoryChanged = v?.value !== state.requiredMachineCategory?.value
        setState(prev => ({
            ...prev,
            requiredMachineCategory: v,
            ...(categoryChanged ? { requiredMachineModelFieldValues: [] } : {}),
        }))
        setSelectedCategory(v)
    }

    return <Animation>
        <ItemsGrid columns={3}>
            <HonestSelectAsyncInput
                labelText='Category'
                nomarg
                link='categories'
                name='category'
                onChange={handleSelect}
                defaultValue={state.requiredMachineCategory?.label}
                parserFunction={(data: any) => data.map(m => ({ fields: m.category.fields, value: m.category.id, label: m.category.name }))}
            />

            <Fragment key={selectedCategory?.value}>{renderFields()}</Fragment>
        </ItemsGrid>
        <TabFooter>
            <Flex gap='1rem'>
                <CancelBtn />
                <Button orange onClick={handleSubmit}>
                    Save
                </Button>
            </Flex>
        </TabFooter>
    </Animation>
}